import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Field, TagSelector } from '@dossierhq/design';
export function StatusTagSelector({ state, dispatch }) {
    if (state.selectedIds.length === 0) {
        return null;
    }
    return (_jsxs(Field, { children: [_jsx(Field.Label, { size: "small", children: "Show entities with status" }), _jsx(Field.Control, { children: _jsx(TagSelector, { clearLabel: "Clear", itemTag: (item) => ({ tag: item.id, color: item.id }), state: state, dispatch: dispatch }) })] }));
}
//# sourceMappingURL=StatusTagSelector.js.map